import { Jersey } from '@/ui/components';
import type { NextTopGoalscorerProps } from './TopGoalscorers.types';

export default function NextTopGoalscorer(props: NextTopGoalscorerProps) {
  const { jerseySrc, topGoalscorer, isAway = false } = props;
  const { name, goals, position, flagSrc } = topGoalscorer;

  const goalsBackgroundClass = isAway ? 'bg-pmw-bar-orange-light' : 'bg-pmw-bar-blue-light';

  return (
    <div className="flex gap-2 items-center">
      <Jersey size={32} jerseySrc={jerseySrc} flagSrc={flagSrc} />
      <div className="flex-1 flex flex-col">
        <span className="text-[12px] leading-[16px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
          {name}
        </span>
        {position && (
          <div className="text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
            {position}
          </div>
        )}
      </div>
      <div
        className={`w-[40px] h-[40px] p-2 flex flex-col items-center justify-center self-center rounded-[12px] text-white font-unibet text-[24px] leading-[24px] ${goalsBackgroundClass}`}
      >
        {goals}
      </div>
    </div>
  );
}
